import { Mesh, MeshBasicMaterial } from 'three';
import { config } from '../../config/config';
export class EdgePiece extends Mesh {
  static materialEdgeExtraPart = new MeshBasicMaterial({ color: config.concreteColor });
  static defaultEdgeColor = config.defaultEdgeColor;
}
